document.addEventListener("DOMContentLoaded", function () {

    // SEARCH BAR TOGGLE
    const searchIcons = document.querySelectorAll(".search_icon");
    const searchBar = document.getElementById("searchBar");
    const closeSearchBar = document.getElementById("closeSearchBar");

    if (searchBar && closeSearchBar) {
        const searchInput = searchBar.querySelector('input[name="s"]');

        searchIcons.forEach(icon => {
            icon.addEventListener("click", function () {
                searchBar.classList.add("search_bar_open");
                document.body.style.overflowY = "hidden";

                // Move focus into the search field (small delay lets the bar become visible)
                if (searchInput) {
                    setTimeout(function () { searchInput.focus(); }, 50);
                }
            });
        });

        closeSearchBar.addEventListener("click", function () {
            searchBar.classList.remove("search_bar_open");
            document.body.style.overflowY = "auto";
        });

        // Close search with Escape
        document.addEventListener("keydown", function (e) {
            if (e.key === "Escape" && searchBar.classList.contains("search_bar_open")) {
                closeSearchBar.click();
            }
        });
    }


    // MEGA MENU TOGGLE
    const menuItems = document.querySelectorAll(".nav > li");
    const megaMenu = document.getElementById("header_mega_menu");

    if (megaMenu) {

        function closeMegaMenu() {
            megaMenu.classList.remove("open");
            megaMenu.innerHTML = "";
        }

        function openMegaMenuFor(item) {
            const subMenu = item.querySelector(".sub-menu");

            if (subMenu) {
                const clone = subMenu.cloneNode(true);
                // Remove IDs from the copy so the page has no duplicate IDs
                clone.querySelectorAll("[id]").forEach(el => el.removeAttribute("id"));

                megaMenu.innerHTML = "";
                megaMenu.appendChild(clone);
                megaMenu.classList.add("open");
            } else {
                closeMegaMenu();
            }
        }

        menuItems.forEach(item => {
            item.addEventListener("mouseenter", function () {
                if (window.innerWidth >= 991) {
                    openMegaMenuFor(item);
                }
            });

            // Keyboard support: open when a top-level link gets focus
            item.addEventListener("focusin", function () {
                if (window.innerWidth >= 991) {
                    openMegaMenuFor(item);
                }
            });
        });

        megaMenu.addEventListener("mouseleave", closeMegaMenu);

        // Escape closes the mega menu
        document.addEventListener("keydown", function (e) {
            if (e.key === "Escape" && megaMenu.classList.contains("open")) {
                closeMegaMenu();
            }
        });
    }


    // MOBILE MENU TOGGLE
    const mobileMenuBtn = document.getElementById("mobileMenuBtn");
    const headerMenu = document.querySelector(".header_menu .nav");
    const header = document.getElementById("mainHeader");

    if (mobileMenuBtn && headerMenu && header) {

        mobileMenuBtn.setAttribute("aria-expanded", "false");

        function updateMenuPosition() {
            if (window.innerWidth >= 991) {
                headerMenu.style.top = "";
                headerMenu.style.height = "";
                return;
            }

            const headerHeight = header.offsetHeight;
            const menuHeight = window.innerHeight - headerHeight;

            headerMenu.style.top = headerHeight + "px";
            headerMenu.style.height = menuHeight + "px";
        }

        function resetMobileMenu() {
            headerMenu.classList.remove("menu_open");
            headerMenu.querySelectorAll(".submenu_open").forEach(li => li.classList.remove("submenu_open"));
            mobileMenuBtn.setAttribute("aria-expanded", "false");
            document.body.style.overflowY = "auto";
        }

        mobileMenuBtn.addEventListener("click", function () {
            const isOpen = headerMenu.classList.toggle("menu_open");

            updateMenuPosition();
            mobileMenuBtn.setAttribute("aria-expanded", isOpen ? "true" : "false");

            if (isOpen) {
                document.body.style.overflowY = "hidden";
            } else {
                document.body.style.overflowY = "auto";
            }
        });

        window.addEventListener("resize", function () {
            if (window.innerWidth >= 991) {
                resetMobileMenu();
            }
            updateMenuPosition();
        });
        window.addEventListener("scroll", updateMenuPosition, { passive: true });

        const mobileItems = headerMenu.querySelectorAll("li");

        mobileItems.forEach(li => {
            const submenu = li.querySelector(":scope > ul");

            if (submenu) {
                li.classList.add("has-submenu");

                const parentLink = li.querySelector(":scope > a");

                if (parentLink) {
                    parentLink.addEventListener("click", function (e) {
                        if (window.innerWidth >= 991) return;

                        e.preventDefault();
                        li.classList.toggle("submenu_open");
                    });
                }
            }
        });

    }

    // Reveal on scroll
    function reveal() {
        var reveals = document.querySelectorAll(".reveal");
        for (var i = 0; i < reveals.length; i++) {
            var windowHeight = window.innerHeight;
            var elementTop = reveals[i].getBoundingClientRect().top;
            var elementVisible = 150;
            if (elementTop < windowHeight - elementVisible) {
                reveals[i].classList.add("reaveal_item");
            } else {
                reveals[i].classList.remove("reaveal_item");
            }
        }
    }
    window.addEventListener("scroll", reveal, { passive: true });
    reveal();
});


// DONATE MODAL
(function () {

    function getModal() {
        return document.getElementById('donate-popup');
    }

    function openDonate(modal) {
        modal.style.display = 'flex';
        document.body.classList.add('modal_open');
    }

    function closeDonate(modal) {
        modal.style.display = 'none';
        document.body.classList.remove('modal_open');
    }

    document.addEventListener('click', function (e) {
        var modal = getModal();
        if (!modal) return; // modal only exists on the Ways to Give page

        var trigger = e.target.closest('a[href="#donate-popup"]');
        if (trigger) {
            e.preventDefault();
            openDonate(modal);
            return;
        }
        if (e.target.closest('[data-donate-close]')) closeDonate(modal);
    });

    document.addEventListener('keydown', function (e) {
        var modal = getModal();
        if (!modal) return;
        if (e.key === 'Escape' && modal.style.display !== 'none') closeDonate(modal);
    });
})();